// Durations are stored with a plural unit ("months"), which reads wrong at a
// count of one — clubs commonly sell 1-month vouchers and memberships.
export function pluraliseUnit(count, unit) {
  if (!unit) return "";
  return Number(count) === 1 ? unit.replace(/s$/i, "") : unit;
}

// A session length as the club sells it. Services are sold in tiers of a fixed
// length and a client picks between them, so every length has to read in the
// same unit — "1 Hour" beside "90 min" makes two tiers of one service look
// like two different things. Minutes, to match the filters and the pack names
// ("90min x 10") the same client reads on the way here.
export function formatDuration(minutes) {
  const m = parseInt(minutes, 10);
  if (!m || Number.isNaN(m)) return "";
  return `${m} min`;
}

// Money as a club quotes it: whole amounts stay whole, and a price that only
// divides into fractions (a pack's per-session rate) keeps its fils.
export function formatMoney(amount, currency) {
  if (amount == null) return "";
  return `${(currency || "").toUpperCase()} ${Number(amount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
